(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (()=>{
 const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
 function update(section){
  const rail=section.querySelector('.product-rail:not([hidden])'),controls=section.querySelector('.rail-controls');
  const end=rail?Math.max(0,rail.scrollWidth-rail.clientWidth):0,canScroll=end>2;
  if(controls)controls.hidden=!canScroll;
  section.querySelector('[data-rail-prev]')?.toggleAttribute('disabled',!canScroll||rail.scrollLeft<2);
  section.querySelector('[data-rail-next]')?.toggleAttribute('disabled',!canScroll||rail.scrollLeft>=end-2);
 }
 function init(root=document){root.querySelectorAll('.product-showcase').forEach(section=>{section.querySelectorAll('.product-rail').forEach(rail=>{if(rail.dataset.railReady)return;rail.dataset.railReady='true';rail.addEventListener('scroll',()=>update(section),{passive:true});new ResizeObserver(()=>update(section)).observe(rail)});update(section)})}
 document.addEventListener('click',e=>{
  const swatch=e.target.closest('[data-card-colour]');
  if(swatch&&!e.metaKey&&!e.ctrlKey&&!e.shiftKey&&!e.altKey&&e.button===0){
   if(!swatch.dataset.image)return;
   e.preventDefault();const card=swatch.closest('.shop-card'),photo=card.querySelector('[data-card-photo]');
   photo.removeAttribute('srcset');photo.src=swatch.dataset.image;photo.alt=swatch.getAttribute('aria-label');
   card.querySelectorAll('[data-card-colour]').forEach(x=>{x.classList.toggle('is-selected',x===swatch);x.removeAttribute('aria-current')});swatch.setAttribute('aria-current','true');
   card.querySelectorAll('[data-card-link]').forEach(a=>a.href=swatch.href);
   card.querySelector('[data-card-price]').textContent=swatch.dataset.price;
   const old=card.querySelector('[data-card-compare]');old.hidden=!swatch.dataset.compare;old.textContent=swatch.dataset.compare||'';
   const badge=card.querySelector('[data-card-sale]');badge.hidden=!swatch.dataset.saving;badge.textContent=swatch.dataset.saving||'';
   const status=card.querySelector('[data-card-status]');status.textContent=swatch.getAttribute('aria-label');
   return;
  }
  const arrow=e.target.closest('[data-rail-prev],[data-rail-next]');
  if(arrow){if(arrow.disabled)return;const section=arrow.closest('.product-showcase'),rail=section.querySelector('.product-rail:not([hidden])'),card=rail?.querySelector('.card');if(!card)return;const step=card.getBoundingClientRect().width+(parseFloat(getComputedStyle(rail).columnGap)||0);rail.scrollBy({left:(arrow.hasAttribute('data-rail-prev')?-1:1)*step,behavior:reduced()?'instant':'smooth'});return;}
  const tab=e.target.closest('[data-collection-tab]');
  if(tab){const section=tab.closest('.product-showcase');section.querySelectorAll('[data-collection-tab]').forEach(b=>{b.classList.toggle('active',b===tab);b.setAttribute('aria-pressed',String(b===tab))});section.querySelectorAll('[data-collection-panel]').forEach(p=>{p.hidden=p.dataset.collectionPanel!==tab.dataset.collectionTab;if(!p.hidden)p.scrollLeft=0});update(section)}
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
 document.addEventListener('shopify:section:load',e=>init(e.target));document.addEventListener('lure:products-updated',()=>init());
})();
  } catch(e) { console.error(e); }
})();

})();
